import { Injectable } from '@angular/core';
import config from '../../app/config.json';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  protected apiUrl = config.Api.Apiurl;
  private emailForm = `${this.apiUrl}/helper/sendContactForm`;
  constructor(private http: HttpClient) { }

  sendEmail(data: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('accept', 'application/json')
      .set('Content-Type', 'application/json');
    return this.http.post<any>(this.emailForm, data, { headers });
  }
}
